import React from 'react'
import bossAIPng from '../../../img/BOSS-AI.png';

export const Loader = ({height ,width, bgColor, icon, description, bossAI = false }) => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height : height ?? '73vh', width : width ?? '100%' , backgroundColor: bgColor}}>
      {!bossAI && <i className="fa fa-spinner fa-spin fa-2xl" />}
      {bossAI && <img src={bossAIPng} alt="Boss AI" className='pop-effect' style={{ width: '65px', height: '65px'}} />}
      {description && (
        <p style={{ marginTop: '1rem', fontSize: '1.2rem', color: '#555' }}>
          {description}
        </p>
      )}
    </div>
  )
  
}
